import { useState } from "react";
import { Loader2, BellRing } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { CATEGORIES, CATEGORY_KEYS } from "@/lib/activity";
import { useJamaah } from "@/context/JamaahContext";
import { jamaahApi } from "@/lib/jamaahApi";
import { errMsg } from "@/lib/api";

export const Langganan = () => {
  const { jamaah, setJamaah } = useJamaah();
  const [selected, setSelected] = useState(new Set(jamaah.subscriptions || []));
  const [saving, setSaving] = useState(false);

  const toggle = (k) => setSelected((s) => {
    const n = new Set(s);
    n.has(k) ? n.delete(k) : n.add(k);
    return n;
  });

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await jamaahApi.put("/jamaah/me/subscriptions", { categories: [...selected] });
      setJamaah({ ...jamaah, subscriptions: data.subscriptions });
      toast.success("Langganan notifikasi disimpan");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-5" data-testid="portal-langganan">
      <div className="rounded-2xl border border-[#d4af37]/40 bg-[#fdf8e7] p-5 flex gap-3 text-sm text-[#6b5410]">
        <BellRing size={18} className="shrink-0 mt-0.5" />
        <p>Pilih kategori kegiatan yang ingin Anda ikuti. Saat jadwal kegiatan dikonfirmasi pengurus, Anda akan menerima pesan WhatsApp di nomor <b>{jamaah.phone}</b>.</p>
      </div>
      <label className="flex items-center gap-3 rounded-2xl border border-emerald-900/15 bg-white px-4 py-3 cursor-pointer w-fit" data-testid="langganan-select-all">
        <Checkbox checked={selected.size === CATEGORY_KEYS.length} onCheckedChange={(v) => setSelected(new Set(v ? CATEGORY_KEYS : []))} data-testid="langganan-select-all-check" />
        <span className="text-sm font-semibold text-emerald-950">Pilih Semua Kategori</span>
      </label>
      <div className="grid sm:grid-cols-2 gap-3">
        {CATEGORY_KEYS.map((k) => {
          const c = CATEGORIES[k];
          const on = selected.has(k);
          return (
            <label key={k} className={`flex items-center gap-3 rounded-2xl border p-4 cursor-pointer transition-colors ${on ? "border-emerald-700 bg-emerald-50" : "border-emerald-900/10 bg-white hover:bg-emerald-50/50"}`} data-testid={`langganan-item-${k}`}>
              <Checkbox checked={on} onCheckedChange={() => toggle(k)} data-testid={`langganan-check-${k}`} />
              <div className="h-9 w-9 rounded-xl flex items-center justify-center text-white shrink-0" style={{ background: `linear-gradient(135deg, ${c.from}, ${c.to})` }}>
                <c.icon size={16} />
              </div>
              <span className="text-sm font-medium text-emerald-950">{c.label}</span>
            </label>
          );
        })}
      </div>
      <Button onClick={save} className="rounded-full emerald-bg hover:bg-[#145c48]" disabled={saving} data-testid="langganan-save-btn">
        {saving ? <Loader2 className="animate-spin" size={16} /> : `Simpan Langganan (${selected.size})`}
      </Button>
    </div>
  );
};
